import RootState from 'typings/RootState'
import { DashboardData } from './types'
import { Event } from 'features/types/event'

export const selectData = (state: RootState): DashboardData =>
  state.cmpjConstructRoad.data

export const selectEvent = (state: RootState): Event =>
  state.cmpjConstructRoad.event

export const selectSorting = (state: RootState) =>
  state.cmpjConstructRoad.sorting
